var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import EdsIcon from '@eui/ds-icons/lib/es6/Icon';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    default: {
        color: Tokens.colorBrandNeutral400
    },
    defaultBg: {
        background: Tokens.colorBrandNeutral400
    },
    error: {
        color: Tokens.colorTextAlertError
    },
    errorBg: {
        background: Tokens.colorFillAlertError
    },
    iconBackground: {
        alignItems: 'center',
        borderRadius: Tokens.borderRadiusCircle,
        color: Tokens.colorBrandNeutral100,
        display: 'inline-flex',
        height: '1.8125rem',
        justifyContent: 'center',
        verticalAlign: 'middle',
        width: '1.8125rem'
    },
    info: {
        color: Tokens.colorTextAlertNeutral
    },
    infoBg: {
        background: Tokens.colorFillAlertNeutral
    },
    marginBottom2Icon: {
        marginBottom: Tokens.spacingXSmall2
    },
    marginBottomIcon: {
        marginBottom: Tokens.spacingXSmall
    },
    marginLeftIcon: {
        marginLeft: Tokens.spacingXSmall
    },
    marginRightIcon: {
        marginRight: Tokens.spacingXSmall
    },
    marginTop2Icon: {
        marginTop: Tokens.spacingXSmall2
    },
    marginTopIcon: {
        marginTop: Tokens.spacingXSmall
    },
    neutral: {
        color: Tokens.colorBrandNeutral100
    },
    neutralBg: {
        background: Tokens.colorBrandNeutral100
    },
    success: {
        color: Tokens.colorTextAlertSuccess
    },
    successBg: {
        background: Tokens.colorFillAlertSuccess
    },
    warning: {
        color: Tokens.colorTextAlertWarning
    },
    warningBg: {
        background: Tokens.colorFillAlertWarning
    }
});
const Icon = (props, ref) => {
    const { iconWithBackground, className, classes, marginBottom, marginBottom2, marginLeft, marginRight, marginTop, marginTop2, type } = props, rest = __rest(props, ["iconWithBackground", "className", "classes", "marginBottom", "marginBottom2", "marginLeft", "marginRight", "marginTop", "marginTop2", "type"]);
    let classIcon;
    let classIconBg;
    let iconComponent;
    if (type) {
        switch (type) {
            case 'error':
                classIcon = iconWithBackground ? classes.errorBg : classes.error;
                break;
            case 'info':
                classIcon = iconWithBackground ? classes.infoBg : classes.info;
                break;
            case 'success':
                classIcon = iconWithBackground ? classes.successBg : classes.success;
                break;
            case 'warning':
                classIcon = iconWithBackground ? classes.warningBg : classes.warning;
                break;
            case 'neutral':
                classIcon = iconWithBackground ? classes.neutralBg : classes.neutral;
                break;
            case 'default':
                classIcon = iconWithBackground ? classes.defaultBg : classes.default;
                break;
        }
    }
    if (marginBottom) {
        classIcon = classnames(classIcon, classes.marginBottomIcon);
    }
    if (marginBottom2) {
        classIcon = classnames(classIcon, classes.marginBottom2Icon);
    }
    if (marginLeft) {
        classIcon = classnames(classIcon, classes.marginLeftIcon);
    }
    if (marginRight) {
        classIcon = classnames(classIcon, classes.marginRightIcon);
    }
    if (marginTop) {
        classIcon = classnames(classIcon, classes.marginTopIcon);
    }
    if (marginTop2) {
        classIcon = classnames(classIcon, classes.marginTop2Icon);
    }
    if (className) {
        classIcon = classnames(classIcon, className);
    }
    if (iconWithBackground) {
        classIconBg = classnames(classIcon, classes.iconBackground);
        iconComponent = (React.createElement("div", { className: classIconBg },
            React.createElement(EdsIcon, Object.assign({ ref: ref }, rest))));
    }
    else {
        iconComponent = (React.createElement(EdsIcon, Object.assign({ className: classIcon, ref: ref }, rest)));
    }
    return (React.createElement(React.Fragment, null, iconComponent));
};
const IconFRC = forwardRef(Icon);
IconFRC.displayName = 'IconFRC';
export default withStyles(styles, { name: 'IconWS' })(IconFRC);
